import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
}) 
export class IpvalidationService {

 constructor(private http: HttpClient) {}

  getPublicIP(): Observable<string> {
    return this.http.get<any>('https://api.ipify.org?format=json').pipe(
      map(response => response.ip)
    );
  }

validateIP(ip: string): Observable<boolean> {
  const url = `https://api.fargingold.com/api/check-ip?ip=${ip}`;
  const headers = {
    Authorization: 'Bearer d9F4!a3Qp2@kL8zR1wT6yU0mN4bH5eCq7R8xZ0vJ2tM6nB1sW3yP5lD9uK4oE7cV0iQ2fG8hS1jX5rA6bT3mN9wL4pO2vY7zC8qU0kR1eJ6dF5gH2xI3sB9nM0tV7oP4uW5yL8cK1jQ6fE3rA2hZ9vN7mY4lD0pO8wS6xT5iB1qG3kJ2uR7cF4nL0yH8vM9eP6oS5aW2tQ1dC7zX0bN3fK8rY4jL6mV9pI5sU2hO0wE7qL1vT3xR8cD6kN4bA9yJ5gF2oM0zP7'
  };

  return this.http.post(url, {}, { headers, responseType: 'text' }).pipe(
    map(response => {
      return response.includes('IP RANGE FOUND IN DB');
    })
  );
}


  checkIPValidity(): Observable<boolean> {
    return this.getPublicIP().pipe(
      switchMap(ip => this.validateIP(ip))
    );
  }
}
